const IntegrationPathnames = {
  HUBSPOT: "/organizations/general/hubspot-connection",
  SALESFORCE: "/organizations/general/salesforce-connection"
};

export default IntegrationPathnames;
